import { FC } from 'react';
import { useQuery } from '@tanstack/react-query'
import { Text, Toolbar, Tooltip } from '@fluentui/react-components';
import './JobsEdit.css';
import { bind } from '@react-rxjs/core';
import { accessTokenInfo$, isAuthorized$ } from '../oauth/oauth';
import { nodeServer } from '../constants';
import IJob from './IJob';
import LinkRouter from '../LinkRouter';


interface JobsProps {

}

const [useIsAuthorized] = bind(isAuthorized$, isAuthorized$.value);

const JobsEditList: FC<JobsProps> = () => {


    const { data: myJobs } = useQuery({
        queryKey: ['myJobs'],
        refetchOnWindowFocus: false,
        queryFn: async () => {
            if (accessTokenInfo$.value === null || accessTokenInfo$.value.accessToken === null) {
                return [] as IJob[];
            }
            let headers = new Headers();
            headers.append('Content-Type', 'application/json');
            headers.append('Authorization', 'Bearer ' + accessTokenInfo$.value.accessToken);
            let url = nodeServer + `jobs/me`;
            const res = await fetch(url, { headers: headers });
            if (!res.ok) {
                throw new Error('Network response was not ok')
            }
            const jobs: IJob[] = await res.json();

            jobs.forEach(x => {
                x.expiration = new Date(Date.parse(x.expiration as string));
            });

            return jobs;
        }
    });

    const isAuthorized = useIsAuthorized();

    return (
        <>
            {isAuthorized ? (
                <>
                    <div style={{ height: '100%', overflow: 'auto' }}>
                        <h1>My Job Postings</h1>

                        <Toolbar>
                            <Tooltip
                                relationship='description'
                                withArrow
                                positioning={"below"}
                                content="Create a new job and navigate to screen to fill out details.">
                                <LinkRouter as="ToolbarButton" appearance="primary" href='/jobs/edit/new'>Create Job Posting</LinkRouter>
                            </Tooltip>


                        </Toolbar>
                        {/* <List navigationMode='items'> */}
                        {myJobs === undefined ? <></> : myJobs.map(x =>
                        (<div key={x.id}>
                            <LinkRouter href={'/jobs/edit/' + x.id}>
                                <div style={{ display: 'flex', flexDirection: 'column', background: '#00000008', margin: 5, padding: 5, borderRadius: 5 }}>
                                    <Text >{x.title}</Text>
                                    <Text>Expires: {(x.expiration as Date)?.toDateString()}</Text>
                                </div>
                            </LinkRouter>
                        </div>)
                        )}
                        {/* </List> */}
                    </div>
                </>
            ) : (
                <><h2>You're not authorized to see this page.  Sign-in first!</h2></>
            )}



            {/*  */}

        </>
    );
};

export default JobsEditList;
